<template>
  <!-- :layout="layout" -->
  <div>
    <div
      class="subTabClass"
      v-if="
        chartData1 !== null && chartData1.length > 0 && chartData.length > 0
      "
    >
      <PlotlyMultiLineChart
        class="svgChart"
        :data-set="chartData1"
        :xAxisType="xAxisType"
        :yAxisType="yAxisType"
        :margin="margin"
        :title="chartTitle"
        :name="name"
        :chartWidth="chartWidth"
        :chartHeight="chartHeight"
        :tickFormat="tickFormat"
        :commitName="'Custom Index'"
        :yAxisTitle="'Rebased to 100'"
        :sliderHide="true"
        :yearDrop="false"
        :hide_filter_drop_and_drop_Down="false"
        :tickangle="90"
      >
      </PlotlyMultiLineChart>
    </div>
    <div v-else class="no_records_chart">No records available</div>
  </div>
</template>

<script>
// import { Plotly } from "vue-plotly";
import PlotlyMultiLineChart from "@/components/charts/PlotlyCharts/MultiLineChart.vue";

export default {
  name: "PlotlyLineChart",
  components: {
    // Plotly,
    PlotlyMultiLineChart,
  },
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      },
    },
    xField: {
      type: String,
      default: "xField",
    },
    yField: {
      type: String,
      default: "yField",
    },
    name: {
      type: String,
      default: "",
    },
    color: {
      default: "steelblue",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loaded: true,
      set_margin: this.margin
        ? this.margin
        : {
            l: 80,
            r: 10,
            b: 150,
            t: 30,
            pad: 2,
          },
      chartTitle: "",
      // name: "ISM vs. WTI Oil % YoY",
      yAxisType: "linear",
      xAxisType: "date",
      chartWidth: 1250,
      chartHeight: 330,
      tickFormat: "",
      // chartData: [],
      chartData1: [],
      margin: {
        l: 80,
        r: 10,
        b: 120,
        t: 40,
        pad: 2,
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        // console.log("chartData", this.chartData);
        let chart_API_Data = [...this.chartData];
        chart_API_Data.reverse();
        //------------Formatted Data------------
        if (chart_API_Data && chart_API_Data.length) {
          let keyName = "";
          let formattedData = chart_API_Data.map(function(i) {
            keyName = Object.keys(i)[2];
            const d = new Date(i.Date);
            let year = d.getFullYear();
            return {
              lineField: +i[Object.keys(i)[2]],
              lineField1: +i["Custom Index"],
              xField: i.Date,
              year: year,
            };
          });
          formattedData.reverse();
          // console.log("formattedData", formattedData);
          //------------Line Charts------------
          let trace1 = {
            type: "scatter",
            mode: "lines",
            name: keyName,
            x: this.unpack(formattedData, "xField"),
            y: this.unpack(formattedData, "lineField"),
            year: this.unpack(formattedData, "year"),
            xaxis: "x",
            yaxis: "y",
            line: {
              color: "#331539",
            },
          };
          let trace2 = {
            type: "scatter",
            mode: "lines",
            name: "Custom Index",
            x: this.unpack(formattedData, "xField"),
            y: this.unpack(formattedData, "lineField1"),
            year: this.unpack(formattedData, "year"),
            xaxis: "x",
            yaxis: "y",
            line: {
              color: "#EEDBB2",
            },
          };
          this.chartData1 = [];
          setTimeout(() => {
            if (trace1 && trace2) {
              this.chartData1 = [trace1, trace2];
              // console.log("this.chartData1+++", this.chartData1);
            }
          }, 10);
        }
      },
    },
  },
  mounted() {},
  methods: {
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
  },
};
</script>
